import type { GeojsonEditorWrapperProps } from "./geojson-editor.type";

import { Form } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import GeojsonEditor from "./geojson-editor.component";

const GeojsonEditorWrapper = ({
  name,
  label,
  help: serverError,
}: GeojsonEditorWrapperProps) => {
  const { t } = useTranslation();
  const [error, setError] = useState<string | null>(null);
  const hasError = !!error;

  useEffect(() => {
    if (serverError)
      setError(t("global:geojson.serverError", { error: serverError }));
  }, [serverError]);

  return (
    <Form.Item
      name={name ?? "geojson"}
      label={label ?? t("global:geojson.label")}
      validateStatus={hasError ? "error" : ""}
      help={error}
      rules={[
        {
          validator: () => {
            if (error) return Promise.reject();
            return Promise.resolve();
          },
        },
      ]}
      style={{ minHeight: "200px" }}
    >
      <GeojsonEditor onError={setError} />
    </Form.Item>
  );
};

export default GeojsonEditorWrapper;
